import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { isLanguageSupported, getSupportedLanguageCodes } from '../utils/language';
import { getLanguageFromPath } from '../utils/languageRoute';

// 动态加载所有语言文件
const loadLanguageResources = () => {
  const resources: Record<string, { translation: any }> = {};
  const supportedLanguages = getSupportedLanguageCodes();

  // 使用 require.context 动态加载所有语言 JSON 文件（排除 languages.json 配置文件）
  // @ts-ignore - require.context 是 webpack 提供的功能
  const localesContext = require.context('../locales', false, /^(?!.*languages\.json$).*\.json$/);

  supportedLanguages.forEach((langCode) => {
    try {
      // 尝试加载对应的语言文件
      const translationModule = localesContext(`./${langCode}.json`);
      resources[langCode] = {
        translation: translationModule,
      };
    } catch (error) {
      console.warn(`Language file for "${langCode}" not found, skipping...`);
    }
  });

  return resources;
};

// 从 URL 路径中获取语言设置，默认为英文
const getLanguageFromUrl = (): string => {
  if (typeof window === 'undefined') {
    return 'en'; // SSR 环境默认返回英文
  }

  // 1. 优先从 URL 路径中获取语言（如 /en/home, /ko/about）
  const pathLanguage = getLanguageFromPath(window.location.pathname);
  if (pathLanguage && isLanguageSupported(pathLanguage)) {
    return pathLanguage;
  }

  // 2. 其次从 URL 参数中获取语言（如 ?lang=ko）
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang');
  if (langParam && isLanguageSupported(langParam)) {
    return langParam;
  }

  // 3. 默认返回英文
  return 'en';
};

const defaultLanguage = getLanguageFromUrl();
const resources = loadLanguageResources();

i18n.use(initReactI18next).init({
  resources,
  lng: defaultLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
